import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";

export interface ContactSubmission {
    name: string;
    email: string;
    message: string;
}

export const submitContactForm = async (data: ContactSubmission) => {
    const db = getFirestore();

    try {
        const docRef = await addDoc(collection(db, "contactMessages"), {
            ...data,
            dateSent: serverTimestamp(),
        });
        console.log("Contact message written with ID: ", docRef.id);
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error("Error adding contact message: ", error);
        throw error;
    }
};